"use client";

/* eslint-disable jsx-a11y/anchor-is-valid */
import Slider from "component/design-system/carousel/Slider";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { useTranslation } from "next-i18next";
import ServiceSection from "../../components/ServiceSection";
import sliderStyles from "../HomeSliderWrapper.module.scss";
import ServiceCategory from "../ServiceCategory";
import Heading from "../headings/Headings";
import styles from "./regular-service.module.scss";

function RegularService(props: any) {
  const { regularServices } = props;
  const { t } = useTranslation("home");

  return (
    <div className={styles.regular_service_container}>
      <ServiceSection className="p-b-20">

        <Heading
          id="regular-service"
          component="h2"
          heading={t("Buy Auto Parts for Regular Service")}
          fontSize={FONT_SIZE[5]}
          className={styles.heading}
        />

        <PAText component="h4" color="grey-secondary" centerAlign className="m-b-20">
          {t("Save big on essential maintenance parts for your vehicle")}
        </PAText>

        <div className={`${sliderStyles.HomeSliderWrapper}p-t-5`}>
          <Slider
            tileWidth={180}
            showArrowOnHover
            showScrollOnHover
            liClass={styles.regular_service_slider}
          >
            {regularServices.map((category: any) => (
              <div key={category.title} className={styles.slider_item}>

                <ServiceCategory categoryData={category} />
              </div>
            ))}
          </Slider>
        </div>
      </ServiceSection>
    </div>
  );
}

export default RegularService;
